/** @jsx  jsx */
import { css } from '@emotion/core';
import { MediaQueries } from '../../../styles/Grid';

export const hiddenspace = css({
  overflow: 'hidden',
});

export const containerPaddingCss = css({
  padding: '40px 0px',
  overflow: 'hidden',
  '.hiddenextraspace': {
    overflow: 'hidden',
  },
});

export const reviewsWidgetHolder = css({
  marginTop: '128px !important',
  marginBottom: '50px !important',
  fontFamily: 'effra !important',

  '.heading_sec': {
    display: 'flex',
    marginBottom: '56px',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    [MediaQueries.mdAndUp]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    [MediaQueries.sm]: {
      flexDirection: 'column',
      alignItems: 'baseline',
      marginBottom: '36px',
    },

    '.review_top_right': {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      [MediaQueries.md]: {
        alignItems: 'center',
        flexDirection: 'row',
      },
      [MediaQueries.sm]: {
        alignItems: 'baseline',
        flexDirection: 'column',
      },
    },

    img: {
      width: '100%',
      maxWidth: '180px',
      [MediaQueries.md]: {
        maxWidth: '96px',
      },
      [MediaQueries.sm]: {
        maxWidth: '150px',
      },
    },
    h2: {
      fontSize: '34px',
      lineHeight: '40px',
      fontWeight: '500',
      letterSpacing: '-1px',
      [MediaQueries.lg]: {
        fontSize: '34px',
      },
      [MediaQueries.md]: {
        fontSize: '28px',
      },
      [MediaQueries.sm]: {
        fontSize: '28px',
        lineHeight: '40px',
        letterSpacing: 'unset',
        marginBottom: '25px',
      },
    },

    '.heighlight_reviews': {
      display: 'flex',
      fontSize: '14px',

      [MediaQueries.sm]: {
        marginBottom: '20px',
      },

      span: {
        color: '#008385',
        fontWeight: '500',
      },

      div: { paddingRight: '15px' },
    },
  },

  '.swiper-slide': {
    '.boxsec': {
      backgroundColor: '#F4F3F0',
      padding: '26px',
      minHeight: '265px',
      borderRadius: '16px',
      [MediaQueries.sm]: {
        minHeight: '250px',
      },
    },

    '.reviewer-info': {
      fontSize: '18px',
      lineHeight: '32px',
      marginTop: '15px',
      color: '#393939',
      fontWeight: '500',
      marginBottom: '8px',
    },

    '.comment': {
      fontSize: '14px',
      lineHeight: '24px',
      color: '#747475',
      fontWeight: '400',
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: '6',
      WebkitBoxOrient: 'vertical',
    },

    '.timeago': {
      fontSize: '14px',
      lineHeight: '24px',
      color: '#858585',
      position: 'absolute',
      bottom: '32px',
      opacity: '0.25',
      fontWeight: '400',
      marginTop: '16px',
    },
  },

  '#ReviewsWidget': {
    '#ReviewsIo-CardCarousel': {
      '.ReviewsHeading': {
        fontFamily: 'effra !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '76%',
        marginBottom: '56px',

        '.ReviewsHeading__Title': {
          fontSize: '48px !important',
          lineHeight: '56px !important',
          marginBottom: '0px !important',
          marginTop: '0px !important',
          padding: '0px',
          fontWeight: '500 !important',
          letterSpacing: '-1px !important',
          textAlign: 'left!important',
        },

        '.ReviewsHeading__SubTitle': {
          marginBottom: '0px !important',
          strong: {
            color: '#008385',
          },
        },

        '.starCollection': {
          color: '#008385 !important',
          display: 'none !important',
        },
      },

      '.ReviewsCard': {
        background: '#f4f3f0 !important',
        boxShadow: 'none !important',
        fontFamily: 'effra !important',
        height: '330px !important',
        color: '#393939',
        padding: '60px 33px 26px !important',

        '.ReviewsCard__Name': {
          color: '#393939 !important',
          fontSize: '18px !important',
          fontWeight: '500 !important',
          lineHeight: '32px !important',
        },
        '.ReviewsCard__Comments': {
          color: '#393939 !important',
          fontSize: '14px !important',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '24px',
          letterSpacing: '0px',
          textAlign: 'left',
        },

        '.starCollection': {
          color: '#008385 !important',
          position: 'absolute',
          top: '26px',
        },

        '.ReviewsCard__Footer': {
          position: 'relative !important',
          '.footer__time': {
            color: '#008385 !important',
            float: 'left !important',
            paddingLeft: '0 !important',
          },
        },
      },
      '.ReviewsCarouselContainer .\\--arrow-right': {
        right: '-90px',
        width: '146px',
        background:
          'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
      },

      '.ReviewsCarouselContainer .\\--arrow-left': {
        left: '15px',
      },

      '.ReviewsCarouselContainer': {
        marginLeft: '0% !important',
        paddingLeft: '8% !important',
        overflow: 'visible',

        '.ruk-icon-arrow-left-1-01:before': {
          content: '"\fea47"',
          fontSize: '16px',
          fontFamily: 'regus-icon-font',
        },
        '.ruk-icon-arrow-left-1-01': {
          width: '48px',
          height: '48px',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          display: 'flex',
          background: '#fff',
          boxShadow: '0px 5px 20px rgba(0,0,0,0.12)',
        },

        '.ruk-icon-arrow-right-1-01:before': {
          content: '"\fea48"',
          fontSize: '16px',
          fontFamily: 'regus-icon-font',
        },

        '.ruk-icon-arrow-right-1-01': {
          width: '48px',
          height: '48px',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          display: 'flex',
          background: '#fff',
          boxShadow: '0px 5px 20px rgba(0,0,0,0.12)',
        },
      },
    },
    '.ReviewsFooter': {
      position: 'absolute',
      right: '0',
      top: '16px',
    },
  },

  [MediaQueries.md]: {
    marginTop: '96px !important',
    marginBottom: '96px !important',
  },
  [MediaQueries.lg]: {
    marginTop: '96px !important',
    marginBottom: '96px !important',
  },
  [MediaQueries.sm]: {
    marginTop: '64px !important',
    marginBottom: '64px !important',
  },
  [MediaQueries.xl]: {},
});
